import type { ReactElement } from 'react';
import React, { useCallback } from 'react';
import type { NavLinkProps, NavigateProps } from 'react-router-dom';
import { NavLink, Navigate, useLocation, useNavigate } from 'react-router-dom';

export function LinkWithQuery(props: React.PropsWithChildren<NavLinkProps>): ReactElement {
  const { to, children, ...navLinkProps } = props;
  const location = useLocation();

  return (
    <NavLink to={`${to}${location?.search}`} {...navLinkProps}>
      {children}
    </NavLink>
  );
}

export function useNavigateWithQuery(): (to: string) => void {
  const location = useLocation();
  const navigate = useNavigate();

  return useCallback(
    (to: string) => navigate(`${to}${location?.search}`),
    [location?.search, navigate]
  );
}

export function RedirectWithQuery({ to, ...props }: NavigateProps & { to: string }): ReactElement {
  const { search, pathname } = useLocation();
  if (to.startsWith('/')) {
    return <Navigate to={`${to}${search}`} replace {...props} />;
  }

  return <Navigate to={`${pathname}/${to}${search}`} replace {...props} />;
}
